SP.lang.Class.define("SP.sitekit.form.validator.Required", {

	_options: null,

	init: function (options) {
		this._options = options;
	},

	isValid: function (value, control, element) {
		if (element instanceof SP.sitekit.form.field.Map) {
			return value.features.length > 0;
		}
		return (value !== null && value !== "" && value !== false);
	},

	getMessage: function () {
		return this._options.messages.required;
	}
});